module.exports = __webpack_public_path__ + "img/e48.d58ff1f9.png";